import CourseTableContainer from './CourseTableContainer.js';

export default CourseTableContainer;